/* eslint-disable no-plusplus */
/* eslint-disable radix */
export function scrollPageTo(n) {
  window.scrollTo({ top: n, left: 0, behavior: 'smooth' });
}

export function onlyUpperCase(str) {
  if (typeof str !== 'string') return '';
  if (!str) return '';

  return str?.toUpperCase();
}

export function onlyNumbers(str) {
  if (typeof str !== 'string') return '';
  if (!str) return '';

  return str.replace(/\D/g, '');
}

export function numbersAndComa(str) {
  if (typeof str !== 'string') return '';
  if (!str) return '';

  return str.replace(/[^\d,]+/g, '')?.replace(/(,\d{1})\d+/, '$1');
}

export function validateCpf(cpf) {
  if (typeof cpf !== 'string') return false;
  cpf = cpf.replace(/[\s.-]*/gim, '');
  if (
    !cpf ||
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  ) {
    return false;
  }
  let soma = 0;
  let resto;
  for (let i = 1; i <= 9; i++)
    // eslint-disable-next-line radix
    soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;

  /* istanbul ignore next */
  if (resto === 10 || resto === 11) resto = 0;
  // eslint-disable-next-line radix
  if (resto !== parseInt(cpf.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++)
    // eslint-disable-next-line radix
    soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;

  /* istanbul ignore next */
  if (resto === 10 || resto === 11) resto = 0;

  /* istanbul ignore next */
  if (resto !== parseInt(cpf.substring(10, 11))) return false;
  return true;
}

export const cpfMasked = cpf => {
  if (typeof cpf !== 'string') return false;

  const cpfMasked = cpf?.replace(
    /(\d{3})(\d{3})(\d{3})(\d{2})/g,
    '$1.$2.$3-$4'
  );

  return cpfMasked;
};

export function validateEmail(email) {
  const regexFullEmail = /^[a-zA-Z0-9._+-]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,12}))$/;
  const regexHasLetterFirstGroup = /^(?!\d+@)\S+/;
  const regexPreventSpecialBefore = /\+@|\.@/; // get if .@ or +@
  const minCharactersAfter = /@[a-zA-Z0-9]{2,}/;
  const minCharactersBefore = /[a-zA-Z0-9._+-]{2,}@/;

  return (
    regexFullEmail.test(email) &&
    regexHasLetterFirstGroup.test(email) &&
    minCharactersAfter.test(email) &&
    minCharactersBefore.test(email) &&
    !regexPreventSpecialBefore.test(email)
  );
}

export const estadosBrasileiros = [
  { codigo: 'AC', descricao: 'ACRE' },
  { codigo: 'AL', descricao: 'ALAGOAS' },
  { codigo: 'AP', descricao: 'AMAPÁ' },
  { codigo: 'AM', descricao: 'AMAZONAS' },
  { codigo: 'BA', descricao: 'BAHIA' },
  { codigo: 'CE', descricao: 'CEARÁ' },
  { codigo: 'DF', descricao: 'DISTRITO FEDERAL' },
  { codigo: 'ES', descricao: 'ESPÍRITO SANTO' },
  { codigo: 'GO', descricao: 'GOIÁS' },
  { codigo: 'MA', descricao: 'MARANHÃO' },
  { codigo: 'MT', descricao: 'MATO GROSSO' },
  { codigo: 'MS', descricao: 'MATO GROSSO DO SUL' },
  { codigo: 'MG', descricao: 'MINAS GERAIS' },
  { codigo: 'PA', descricao: 'PARÁ' },
  { codigo: 'PB', descricao: 'PARAÍBA' },
  { codigo: 'PR', descricao: 'PARANÁ' },
  { codigo: 'PE', descricao: 'PERNAMBUCO' },
  { codigo: 'PI', descricao: 'PIAUÍ' },
  { codigo: 'RJ', descricao: 'RIO DE JANEIRO' },
  { codigo: 'RN', descricao: 'RIO GRANDE DO NORTE' },
  { codigo: 'RS', descricao: 'RIO GRANDE DO SUL' },
  { codigo: 'RO', descricao: 'RONDÔNIA' },
  { codigo: 'RR', descricao: 'RORAIMA' },
  { codigo: 'SC', descricao: 'SANTA CATARINA' },
  { codigo: 'SP', descricao: 'SÃO PAULO' },
  { codigo: 'SE', descricao: 'SERGIPE' },
  { codigo: 'TO', descricao: 'TOCANTINS' },
];
